<template>
  <div class="quiz-form">
    <CustomModal
      v-if="!isPreviewQuiz"
      id="quiz-form-modal"
      class="basic-modal quiz-form-modal"
      :isCustomFooter="true"
    >
      <div class="new-quiz-title" slot="modal-header">
        {{ isNewQuiz ? '데일리 퀴즈 만들기' : '데일리 퀴즈 수정하기' }}
      </div>
      <div class="new-quiz-body">
        <div class="form-group">
          <h6 class="typography--body-1 typography--color-secondary">
            <strong>
              퀴즈타입 선택
            </strong>
          </h6>
          <Radio
            v-for="(quiz, index) in quizTypes"
            :key="index"
            @change="handleQuizTypeChange(index)"
            :model-value="selectedQuizType"
            :check-value="index"
            :id="`quiz-type-${index}`"
          >
            <span slot="label">{{ quiz.name }}</span>
          </Radio>
        </div>

        <div class="form-group">
          <h6 class="typography--body-1 typography--color-secondary">
            <strong>
              태그 선택
            </strong>
          </h6>
          <div class="typography--body-3 typography--color-disabled mb-8">
            최대 2개까지 선택 가능합니다.
          </div>
          <div
            class="tag"
            :class="{ selected: isSelectedTag(value) }"
            @click="handleTagClick(value)"
            v-for="(value, index) in tags"
            :key="index"
          >
            {{ `#${value.name}` }}
          </div>
        </div>

        <div class="form-group">
          <h6 class="typography--body-1 typography--color-secondary">
            <strong>
              문제 입력
            </strong>
          </h6>
          <div class="field-wrapper">
            <div class="textarea-wrapper w-100">
              <AutosizeTextarea
                v-model="content"
                :placeholder="'문제를 입력해주세요.'"
                :limit="40"
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <h6 class="typography--body-1 typography--color-secondary">
            <strong>
              보기 입력
            </strong>
          </h6>
          <div class="field-wrapper" v-for="(option, index) in options" :key="index">
            <div class="textarea-wrapper">
              <AutosizeTextarea
                :isDisabled="isNoOptionsQuiz(options)"
                v-model="option.value"
                :placeholder="$t('page_editor.choices.placeholder')"
                :limit="10"
              />
            </div>

            <div class="option-wrapper float-right">
              <Radio
                @change="handleOptionChange(option.key)"
                :model-value="selectedOption"
                :check-value="index"
                :id="`option-${index}`"
                left-label="true"
              >
                <span
                  class="typography--body-3 typography--color-secondary"
                  slot="left-label"
                  v-if="false"
                >
                  {{ $t('page_editor.choices.is_correct') }}
                </span>
              </Radio>
            </div>
          </div>
        </div>

        <div class="form-group">
          <h6 class="typography--body-1 typography--color-secondary">
            <strong>
              문제 해설
            </strong>
          </h6>
          <div class="field-wrapper">
            <div class="textarea-wrapper w-100">
              <AutosizeTextarea
                v-model="answer"
                :placeholder="'해설을 입력해주세요.'"
                :limit="40"
              />
            </div>
          </div>
        </div>
      </div>

      <div slot="modal-footer">
        <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
          취소
        </button>
        <button
          v-if="isNewQuiz"
          type="button"
          class="btn btn-secondary"
          @click="handlePreviewQuizClick"
        >
          미리보기
        </button>
        <button
          v-if="isNewQuiz"
          type="button"
          class="btn btn-primary"
          @click="handleNewQuizClick"
          :disabled="isDisabledQuiz"
        >
          <template v-if="!isLoading">저장</template>
          <LoadingBounce v-else></LoadingBounce>
        </button>
        <button
          v-if="!isNewQuiz"
          type="button"
          class="btn btn-secondary"
          @click="handleUpdateQuizClick"
          :disabled="isDisabledQuiz"
        >
          수정
        </button>
      </div>
    </CustomModal>
    <CustomModal
      v-if="isPreviewQuiz"
      id="quiz-preview-modal"
      class="basic-modal quiz-preview-modal"
      :isHideFooter="true"
    >
      <div class="quiz-preview-title" slot="modal-header" @click="handlePreviewCloseClick">
        <img class="back-icon" src="/static/images/ic-arrow-back.svg" />
        미리보기
      </div>
      <QuizPreview :quiz="getPreviewQuizData"/>
    </CustomModal>
  </div>
</template>

<script>
  import { map, range, isEmpty, find, filter, split, findIndex, head } from 'lodash';
  import { mapGetters, mapActions } from 'vuex';

  import QuizPreview from '../components/QuizPreview';
  import quiz from '../mixins/quiz';

  export default {
    name: 'quiz-form-modal',

    props: {
      quiz: {
        type: Object,
        default: {},
      },
    },

    mixins: [
      quiz,
    ],

    data() {
      return {
        isPreviewQuiz: false,
        selectedQuizType: 0,
        quizTypes: [
          { name: '객관식(4지선다)', options_label: '보기 입력', options_count: 4 },
          { name: 'OX퀴즈', options_label: '정답 입력', options_count: 2 },
        ],
        tags: [
          { name: '상식', color: '' },
          { name: '넌센스', color: '' },
          { name: '일상', color: '' },
          { name: '명언', color: '' },
          { name: '효도', color: '' },
          { name: '시사', color: '' },
          { name: '경제', color: '' },
          { name: '동물', color: '' },
          { name: '신체', color: '' },
          { name: '맞춤법', color: '' },
          { name: '외국어', color: '' },
        ],
        selectedTags: [],
        content: '',
        options: [],
        selectedOption: 0,
        answer: '',
      };
    },

    components: {
      QuizPreview,
    },

    methods: {
      ...mapActions([
        'createQuiz',
        'updateQuiz',
      ]),

      handleTagClick(value) {
        if (this.isSelectedTag(value)) {
          this.selectedTags = filter(this.selectedTags, item => item.name !== value.name);
          return;
        }

        this.selectedTags.push(value);
      },

      async handleNewQuizClick() {
        if (this.isEmptyQuiz) {
          return;
        }

        const data = {
          content: this.content,
          options: JSON.stringify(this.getQuizOptions(this.options)),
          tags: this.getTags,
        };

        await this.createQuiz(data);
        await this.$emit('cancel');
      },

      async handleUpdateQuizClick() {
        if (!this.quiz.id) {
          return;
        }

        const data = {
          id: this.quiz.id,
          content: this.content,
          options: JSON.stringify(this.getQuizOptions(this.options)),
          tags: this.getTags,
        };

        await this.updateQuiz(data);
        await this.$emit('cancel');
      },

      isSelectedTag(value) {
        return !isEmpty(find(this.selectedTags, { name: value.name }));
      },

      isCorrectOption(option) {
        return option.key === this.selectedOption;
      },

      handleQuizTypeChange(value) {
        this.selectedQuizType = value;
        this.options = this.getNewQuizOptions();
      },

      getNewQuizOptions() {
        if (this.selectedQuizType === 1) {
          return [
            {
              value: 'O',
              is_answer: true,
              key: 0,
            },
            {
              value: 'X',
              is_answer: false,
              key: 1,
            },
          ];
        }

        return map(range(this.quizType.options_count), item => ({
          value: '',
          is_answer: false,
          key: item,
        }));
      },

      handleOptionChange(value) {
        this.selectedOption = value;
      },

      handlePreviewQuizClick() {
        this.isPreviewQuiz = true;
      },

      handlePreviewCloseClick() {
        this.isPreviewQuiz = false;
      },

      getQuizOptions(options) {
        return map(options, (item, index) => ({
          key: index,
          value: item.value,
          is_answer: this.isCorrectOption(item),
          answer: this.answer,
        }));
      },
    },

    computed: {
      ...mapGetters({
        isLoading: 'isLoadingQuiz',
      }),

      quizType() {
        return this.quizTypes[this.selectedQuizType];
      },

      isDisabledTags() {
        const LIMIT_TABS = 2;
        return this.selectedTags.length > LIMIT_TABS || this.selectedTags.length === 0;
      },

      isDisabledQuiz() {
        return this.content.length === 0
          || this.isDisabledTags
          || !isEmpty(filter(this.options, item => item.value.length === 0))
          || this.answer.length === 0;
      },

      isNewQuiz() {
        return isEmpty(this.quiz);
      },

      getTags() {
        return map(this.selectedTags, 'name').join(',');
      },

      getPreviewQuizData() {
        return {
          content: this.content,
          options: this.getQuizOptions(this.options),
          tags: this.getTags,
        };
      },

    },

    beforeMount() {
      if (!this.isNewQuiz) {
        const option = head(this.quiz.options);
        const tags = map(split(this.quiz.tags, ',', this.tags.length), item => ({ name: item }));
        this.content = this.quiz.content;
        this.options = this.getQuizOptions(this.quiz.options);
        this.selectedQuizType = this.isNoOptionsQuiz(this.quiz.options) ? 1 : 0;
        this.selectedTags = filter(this.tags, item => (find(tags, { name: item.name })));
        this.selectedOption = findIndex(this.quiz.options, { is_answer: true });
        this.answer = option.answer || '';
      }

      if (this.isNewQuiz) {
        this.options = this.getNewQuizOptions();
      }
    },
  };
</script>

<style lang="scss" scoped>
.quiz-form-modal {

  .new-quiz-body {
    height: 640px;

    .tag {
      display: inline-block;
      width: 64px;
      height: 36px;
      border-radius: 18px;
      border: solid 1px #9013fe;
      color: #9013fe;
      text-align: center;
      line-height: 2.4;
      margin: 5px;
      cursor: pointer;

      &.selected {
        background: #9013fe;
        color: #ffffff;
      }
    }
    
    .field-wrapper {
      border-radius: 4px;
      background-color: #ffffff;
      border: solid 1px rgba(0, 0, 0, 0.26);
      margin-bottom: 12px;
      padding: 8px 14px;
      padding-right: 14px;
      position: relative;

      .textarea-wrapper {
        display: inline-block;
        line-height: 1.0;
        width: 80%;
        max-width: 100%;
        padding: 8px 0 8px 0;

        textarea {
          width: 100%;
          font-size: 16px;
          font-weight: 400;
          line-height: 1.2;
          color: #212121;
          outline: none;
          padding: 0;
          border: none;

          &::placeholder {
            color: rgba(0, 0, 0, 0.26);
          }
        }

      }

      .option-wrapper {
        display: inline-block;
        margin: 4px 0px 0px 0px;
        position: absolute;
        right: 6px;
        bottom: 4px;
      }

      &.has-error {
        border: solid 1px rgba(233, 30, 99, 0.87);

        textarea {
          color: rgba(233, 30, 99, 0.87);
        }
      }
    }
  }
}

.quiz-preview-modal {
  .quiz-preview-title {
    display: flex;
    align-items: center;

    .back-icon {
      cursor: pointer;
      margin: 0 4px 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/my-quizzes/components/QuizFormModal.vue